module.exports = __webpack_public_path__ + "img/diamond_banner_TG.8d4715a5.png";